import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { message, Dropdown, Modal, Input, Button } from 'antd';
import { clstagStr } from '../../../utils/util';
import { CLSTAG } from '../../../utils/constant';
import { TakeOverStatus } from '@/views/PatrolMode/types';
import PassTrafficLightButton from './PassTrafficLightButton';
import { request } from '../../../fetch/core';
import qs from 'qs';
import dayjs from 'dayjs';
import { HttpStatusCode } from '../../../fetch/core/constant';
import type { MenuProps } from 'antd';
import SpeedLimitModal from './SpeedLimitModal';
import SimInfoModal from './SimInfoModal';

interface Props {
  isStoped: boolean;
  disabled: boolean;
  supplierDisabled: boolean;
  takeOverStatus: string;
  operatorIsSelf: boolean | undefined;
  onShowMessage: (param: 'TRAFFIC_LIGHT') => void;
}

const VehicleCommand = (props: Props) => {
  const {
    isStoped,
    operatorIsSelf,
    disabled,
    takeOverStatus,
    supplierDisabled,
  } = props;

  // 获取vehicleName参数
  const query = qs.parse(window.location.search.split('?')[1]);
  const vehicleName = query && query.license;

  // 调度路线modal状态
  const [modalVisible, setModalVisible] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState('');
  // 车辆限速modal状态
  const [speedLimitModalVisible, setSpeedLimitModalVisible] = useState(false);
  const [simInfoModalVisible, setSimInfoModalVisible] = useState(false);

  // 车辆发车逻辑
  const handleVehicleDispatch = async () => {
    if (!vehicleName) {
      message.error('无法获取车辆信息');
      return;
    }

    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/schedule/reloadTask',
        body: {
          vehicleName: vehicleName,
          timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        },
      });

      if (res.code === HttpStatusCode.Success) {
        message.success('车辆发车指令已下发');
      } else {
        message.error(res.message || '车辆发车指令下发失败');
      }
    } catch (error) {
      message.error('车辆发车指令下发失败');
    }
  };
  // 调度路线逻辑
  const handleScheduleRoute = async () => {
    // 获取vehicleName参数
    const query = qs.parse(window.location.search.split('?')[1]);
    const vehicleName = query && query.license;

    if (!vehicleName) {
      message.error('无法获取车辆信息');
      return;
    }

    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/schedule/getScheduleRoute',
        body: {
          vehicleName: vehicleName,
          timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        },
      });

      if (res.code === HttpStatusCode.Success) {
        if (res.data) {
          // 按index排序stopList
          const sortedStops = res.data.stopList.sort(
            (a: any, b: any) => a.index - b.index
          );
          // 用逗号拼接stopName
          const stopNames = sortedStops
            .map((stop: any) => stop.stopName)
            .join(', ');

          setScheduleInfo(`调度路线: ${stopNames}`);
          setModalVisible(true);
        }
      } else {
        message.error(res.message || '获取调度路线失败');
      }
    } catch (error) {
      message.error('获取调度路线失败');
    }
  };

  const handleLimitSpeed = () => {
    if (supplierDisabled) {
      return;
    }
    setSpeedLimitModalVisible(true);
  };

  const handleCloseLimitSpeedModal = useCallback(() => {
    setSpeedLimitModalVisible(false);
  }, [vehicleName]);

  const handleClickSimInfo = () => {
    setSimInfoModalVisible(true);
  };
  const menu: MenuProps['items'] = [
    {
      key: '5',
      label: (
        <span
          className="vehicle-command-menu-item"
          onClick={handleClickSimInfo}
        >
          网络信息
        </span>
      ),
    },
    {
      key: '4',
      label: (
        <span
          className="vehicle-command-menu-item"
          onClick={handleScheduleRoute}
        >
          调度路线
        </span>
      ),
    },
    {
      key: '3',
      label: (
        <span
          className="vehicle-command-menu-item"
          onClick={handleVehicleDispatch}
        >
          车辆发车
        </span>
      ),
    },
    {
      key: '2',
      label: (
        <PassTrafficLightButton
          isStoped={isStoped}
          disabled={disabled}
          takeOverStatus={takeOverStatus}
          operatorIsSelf={operatorIsSelf}
          onShowMessage={props.onShowMessage}
        />
      ),
    },
    {
      key: '1',
      label: (
        <span
          className={classNames('vehicle-command-menu-item', {
            disabled: supplierDisabled,
          })}
          onClick={handleLimitSpeed}
        >
          车辆限速
        </span>
      ),
    },
  ];
  return (
    <>
      <li
        className={classNames('item', {
          cross: true,
        })}
        clstag={clstagStr(CLSTAG.PassTrafficLightBtnClick)}
      >
        <Dropdown
          menu={{ items: menu }}
          trigger={['click']}
          placement="bottomCenter"
        >
          <div style={{ cursor: 'pointer' }}>
            <div className="img_normal" />
            <h3 className="operate_key">车辆指令</h3>
          </div>
        </Dropdown>
      </li>
      <Modal
        title="调度路线信息"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <pre>{scheduleInfo}</pre>
      </Modal>
      {speedLimitModalVisible && (
        <SpeedLimitModal
          visible={speedLimitModalVisible}
          vehicleName={vehicleName}
          handleCloseLimitSpeedModal={handleCloseLimitSpeedModal}
        />
      )}
      {simInfoModalVisible && (
        <SimInfoModal
          visible={simInfoModalVisible}
          vehicleName={vehicleName}
          onClose={() => setSimInfoModalVisible(false)}
        />
      )}
    </>
  );
};

export default VehicleCommand;
